import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { stitchUser, clearUser, trackEvent } from "@/lib/analytics";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
        if (data?.id) stitchUser(data.id);
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("gs_token", data.token);
    setUser(data.user);
    stitchUser(data.user?.id);
    trackEvent("LOGIN");
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    if (data.token) localStorage.setItem("gs_token", data.token);
    setUser(data.user);
    stitchUser(data.user?.id);
    trackEvent("SIGNUP_COMPLETED");
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("gs_token");
    clearUser();
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
